__turbopack_context__.v({
  "discardDraftLink": "b_QzGG_discardDraftLink",
  "objectiveCancelBtn": "b_QzGG_objectiveCancelBtn",
  "objectiveCharCount": "b_QzGG_objectiveCharCount",
  "objectiveCreateBtn": "b_QzGG_objectiveCreateBtn",
  "objectiveCreateForm": "b_QzGG_objectiveCreateForm",
  "objectiveCreateInput": "b_QzGG_objectiveCreateInput",
  "objectiveCreateMeta": "b_QzGG_objectiveCreateMeta",
  "objectiveField": "b_QzGG_objectiveField",
  "objectiveLabel": "b_QzGG_objectiveLabel",
  "root": "b_QzGG_root",
  "titleRow": "b_QzGG_titleRow",
});
